export default __webpack_public_path__ + "static/summer_containers90-f15884ebafa922eca1a0ff8a45df4518.webp";